module.exports = __webpack_public_path__ + "static/media/logo1.73d0ef38.png";